export default class AdminUsers {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminsEndpoint}`, {
      params
    })
  }

  fetch(user_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminsEndpoint}/${user_id}`)
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminsEndpoint}`, payload)
  }

  update(user_id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminsEndpoint}/${user_id}`, payload)
  }

  resendEmailConfirmation(user_id) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminsEndpoint}/${user_id}/account/confirmation/resend`)
  }

  resetMFA(user_id) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminsEndpoint}/${user_id}/account/mfa/reset`)
  }
}
